/**
 * @file OperationsDailyReportPage.jsx
 * @description OPERATIONS department — Daily Report.
 *
 * The day's story machine by machine: ran / did not run / moved / overtime,
 * working hours, first-on and last-on. Invoices are NOT here — Operations has
 * its own Log Sheets header for the invoice downloader.
 *
 * This file belongs to the OPERATIONS department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for OPERATIONS is made HERE and can never leak into another
 * department's screens. The shared engine underneath (DailyReportPage) and the
 * backend stay common — only the department-facing page is departmental.
 */
import React from 'react';
import DailyReportPage from '../DailyReportPage';

const OperationsDailyReportPage = () => (<DailyReportPage forcedTeam="rental" hideInvoices />);

export default OperationsDailyReportPage;
